<form class="container-fluid" [formGroup]="DateSelectionFormGroup">
  <div class="row row-padding">
    <div class="col">
      <label class="fs-24">Select a Date Range</label>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col">
      <label>Start Date</label>
      <div class="input-group">
        <input
          class="form-control"
          (ngModelChange)="startDateChanged()"
          type="text"
          placeholder="MM/DD/YYYY"
          formControlName="startDate"
          navigation="select"
          [maxDate]="maxDatePickerDate"
          [minDate]="minDatePickerDate"
          ngbDatepicker
          container="body"
          #startDatePicker="ngbDatepicker"
          appNgbDateInputMask
        />
        <button
          class="btn btn-primary datepicker-button btn-outline-secondary bi bi-calendar"
          (click)="startDatePicker.toggle()"
          type="button"
        ></button>
      </div>
    </div>
    <div class="col">
      <label>End Date</label>
      <div class="input-group">
        <input
          class="form-control"
          type="text"
          placeholder="MM/DD/YYYY"
          formControlName="endDate"
          navigation="select"
          [maxDate]="maxDatePickerDate"
          [minDate]="minEndDatePickerDate"
          ngbDatepicker
          container="body"
          #endDatePicker="ngbDatepicker"
          appNgbDateInputMask
        />
        <button
          class="btn btn-primary datepicker-button btn-outline-secondary bi bi-calendar"
          (click)="endDatePicker.toggle()"
          type="button"
        ></button>
      </div>
    </div>
  </div>

  <div class="row row-padding">
    <div class="col">
      <button class="btn btn-secondary" (click)="close()">Cancel</button>
    </div>
    <div class="col">
      <button class="btn btn-primary" (click)="continue()">Continue</button>
    </div>
  </div>
</form>
